// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Homepage V2 — Section polish pass (v1).
 * Section-level refinements built on homepageV2Foundation.css tokens.
 * Scoped to .mh2v2-page — no architecture changes.
 */

/* ── 1. Hero ───────────────────────────────────────────── */

.mh2v2-page .mh2v2-hero {
  max-width: none;
  width: 100%;
  min-height: clamp(520px, 58vh, 680px);
  padding: var(--mh2-space-2xl) var(--mh2-container-gutter);
  border-radius: 0;
}

.mh2v2-page .mh2v2-hero__overlay {
  padding: var(--mh2-space-xl) var(--mh2-container-gutter);
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.12) 0%,
    rgba(75, 68, 80, 0.22) 100%
  );
}

.mh2v2-page .mh2v2-hero__overlay.mh2v2-container {
  width: min(var(--container), calc(100% - (var(--mh2-container-gutter) * 2)));
}

.mh2v2-page .mh2v2-hero__title {
  max-width: 14ch;
  margin: 0 auto var(--mh2-space-lg);
  text-shadow:
    0 2px 8px rgba(0, 0, 0, 0.18),
    0 8px 28px rgba(0, 0, 0, 0.12);
}

.mh2v2-page .mh2v2-hero .mh2v2-pill {
  margin-top: var(--mh2-space-sm);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);
}

/* ── 2. Welcome / What's Happening ─────────────────────── */

.mh2v2-page .mh2v2-welcome .mh2v2-script {
  color: #d9737f;
  margin-bottom: var(--mh2-space-lg);
  max-width: 880px;
}

.mh2v2-page .mh2v2-welcome .mh2v2-copy--center {
  max-width: 720px;
  margin-bottom: var(--mh2-space-xs);
}

.mh2v2-page .mh2v2-region-row {
  gap: var(--mh2-space-md);
  margin-top: var(--mh2-space-xl);
}

.mh2v2-page .mh2v2-happening-grid {
  margin-top: var(--mh2-space-2xl);
  grid-template-columns: 1.25fr 0.88fr;
  gap: var(--mh2-gap-lg);
}

.mh2v2-page .mh2v2-happening-left .mh2v2-section-title {
  margin-bottom: var(--mh2-space-lg);
}

.mh2v2-page .mh2v2-happening-card {
  padding: var(--mh2-space-md) var(--mh2-space-lg);
}

.mh2v2-page .mh2v2-happening-card__body h4 {
  font-size: 1.08rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.mh2v2-page .mh2v2-happening-card__body p {
  line-height: var(--mh2-line-body);
  opacity: 0.92;
}

.mh2v2-page .mh2v2-membership-box {
  padding: var(--mh2-space-xl) var(--mh2-space-lg);
  box-shadow: 0 12px 36px rgba(75, 68, 80, 0.1);
}

.mh2v2-page .mh2v2-membership-box .mh2v2-section-title {
  margin-bottom: var(--mh2-space-lg);
}

.mh2v2-page .mh2v2-membership-tier p {
  line-height: var(--mh2-line-body);
  margin-bottom: var(--mh2-space-md);
}

.mh2v2-page .mh2v2-membership-divider {
  margin: var(--mh2-space-lg) 0;
}

/* ── 3. Featured Stories ───────────────────────────────── */

.mh2v2-page .mh2v2-stories {
  background: #d5b95a;
}

.mh2v2-page .mh2v2-stories .mh2v2-section-title {
  margin-bottom: var(--mh2-space-xl);
}

.mh2v2-page .mh2v2-story-card {
  background: var(--white);
  border: 1px solid rgba(75, 68, 80, 0.07);
}

.mh2v2-page .mh2v2-story-card img {
  height: 210px;
  object-position: center 30%;
}

.mh2v2-page .mh2v2-story-card__content {
  flex-direction: column;
  align-items: flex-start;
  padding: var(--mh2-card-padding-lg);
  gap: var(--mh2-space-md);
}

.mh2v2-page .mh2v2-story-card__content p {
  font-size: var(--mh2-size-body-sm);
  line-height: var(--mh2-line-body);
  font-weight: 600;
  color: var(--text);
}

.mh2v2-page .mh2v2-story-card .mh2v2-inline-btn {
  align-self: flex-start;
}

/* ── 4. What's Happening Now (Events) ──────────────────── */

.mh2v2-page .mh2v2-now .mh2v2-section-title {
  margin-bottom: var(--mh2-space-xl);
}

.mh2v2-page .mh2v2-now-card {
  min-height: 400px;
}

.mh2v2-page .mh2v2-now-card img {
  height: 100%;
  min-height: 400px;
  object-position: center 35%;
}

.mh2v2-page .mh2v2-now-card__overlay {
  background: linear-gradient(
    to top,
    rgba(111, 159, 154, 0.88) 0%,
    rgba(75, 68, 80, 0.15) 55%,
    transparent 100%
  );
  padding: var(--mh2-space-xl) var(--mh2-space-lg);
}

.mh2v2-page .mh2v2-now-card__overlay h4 {
  font-size: clamp(2.2rem, 3.5vw, 3rem);
  line-height: 0.95;
  margin-bottom: var(--mh2-space-md);
  text-shadow: 0 3px 14px rgba(0, 0, 0, 0.2);
}

.mh2v2-page .mh2v2-now-card__footer p {
  line-height: var(--mh2-line-body);
  max-width: 220px;
}

/* ── 5. Signature Programs ─────────────────────────────── */

.mh2v2-page .mh2v2-programs.mh2v2-section-charcoal {
  background: #4f4853;
}

.mh2v2-page .mh2v2-programs .mh2v2-section-title {
  margin-bottom: var(--mh2-space-xl);
}

.mh2v2-page .mh2v2-program-list {
  gap: var(--mh2-gap-md);
}

.mh2v2-page .mh2v2-program-card__media {
  height: 165px;
}

.mh2v2-page .mh2v2-program-card__media img {
  object-position: center 30%;
}

.mh2v2-page .mh2v2-program-card__overlay {
  gap: var(--mh2-space-md);
  padding: var(--mh2-space-lg) var(--mh2-space-xl);
}

.mh2v2-page .mh2v2-program-card__overlay .mh2v2-pill {
  margin: var(--mh2-space-xs) 0;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
}

.mh2v2-page .mh2v2-program-card__overlay p {
  line-height: var(--mh2-line-body);
  opacity: 0.95;
}

/* ── 6. Testimonials ─────────────────────────────────────── */

.mh2v2-page .mh2v2-testimonials .mh2v2-section-title {
  margin-bottom: var(--mh2-space-xl);
}

.mh2v2-page .mh2v2-testimonial-list {
  gap: var(--mh2-gap-md);
}

.mh2v2-page .mh2v2-testimonial__media {
  min-height: 300px;
}

.mh2v2-page .mh2v2-testimonial__media img {
  object-position: center 25%;
}

.mh2v2-page .mh2v2-testimonial__content {
  padding: var(--mh2-space-2xl) var(--mh2-space-xl);
  gap: var(--mh2-space-sm);
}

.mh2v2-page .mh2v2-testimonial__content h4 {
  line-height: 1.08;
  margin-bottom: var(--mh2-space-md);
}

.mh2v2-page .mh2v2-testimonial__content p {
  margin-bottom: var(--mh2-space-md);
}

.mh2v2-page .mh2v2-testimonial__content strong {
  font-size: 1.1rem;
  margin-top: var(--mh2-space-sm);
}

.mh2v2-page .mh2v2-testimonial__content span {
  font-size: var(--mh2-size-body-sm);
  opacity: 0.88;
  margin-top: var(--mh2-space-xs);
}

/* ── 7. The M List ───────────────────────────────────────── */

.mh2v2-page .mh2v2-mlist-hero {
  overflow: hidden;
}

.mh2v2-page .mh2v2-mlist-hero::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(to right, rgba(75, 68, 80, 0.08), transparent 40%);
  pointer-events: none;
}

.mh2v2-page .mh2v2-mlist-hero img {
  height: 280px;
  object-position: center 40%;
}

.mh2v2-page .mh2v2-mlist .mh2v2-copy--center {
  max-width: 680px;
  margin-bottom: var(--mh2-space-md);
}

.mh2v2-page .mh2v2-center-actions {
  gap: var(--mh2-space-md);
  margin: var(--mh2-space-lg) 0 var(--mh2-space-xl);
}

.mh2v2-page .mh2v2-center-actions .mh2v2-pill + .mh2v2-pill {
  background: transparent;
  color: var(--gold);
  border: 2px solid var(--gold);
  box-shadow: none;
}

.mh2v2-page .mh2v2-center-actions .mh2v2-pill + .mh2v2-pill:hover {
  background: rgba(216, 176, 78, 0.12);
  transform: translateY(-2px);
}

.mh2v2-page .mh2v2-mlist .mh2v2-section-title + .mh2v2-section-title,
.mh2v2-page .mh2v2-mlist h4.mh2v2-section-title {
  margin-top: var(--mh2-space-xl);
  margin-bottom: var(--mh2-space-lg);
}

.mh2v2-page .mh2v2-category-card img {
  height: 220px;
  object-position: center 30%;
}

.mh2v2-page .mh2v2-category-card__overlay h5 {
  font-size: clamp(2.2rem, 3vw, 2.8rem);
  margin-bottom: var(--mh2-space-md);
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
}

.mh2v2-page .mh2v2-category-links {
  gap: var(--mh2-space-sm);
  padding: var(--mh2-space-md);
}

.mh2v2-page .mh2v2-category-link {
  font-size: 0.88rem;
  padding: 10px var(--mh2-space-md);
}

/* ── 8. Collective / Founder / About ───────────────────── */

.mh2v2-page .mh2v2-collective .mh2v2-section-title {
  margin-bottom: var(--mh2-space-xl);
}

.mh2v2-page .mh2v2-collective-info p {
  line-height: var(--mh2-line-body);
  margin-bottom: var(--mh2-space-md);
}

.mh2v2-page .mh2v2-quote-chip {
  border-radius: var(--mh2-card-radius);
  padding: var(--mh2-space-lg) var(--mh2-space-xl);
  margin-top: var(--mh2-gap-lg);
  font-size: clamp(1.3rem, 2.5vw, 1.6rem);
  line-height: 1.15;
}

.mh2v2-page .mh2v2-founder-panel img {
  height: 340px;
  object-position: center 20%;
}

.mh2v2-page .mh2v2-founder-panel__body {
  padding-top: var(--mh2-space-md);
  gap: var(--mh2-space-md);
}

.mh2v2-page .mh2v2-founder-panel__body p {
  line-height: var(--mh2-line-body);
}

.mh2v2-page .mh2v2-about.mh2v2-section-charcoal {
  background: #4f4853;
}

.mh2v2-page .mh2v2-about-founder img {
  height: 400px;
  object-position: center 15%;
}

.mh2v2-page .mh2v2-about-founder__caption {
  margin-top: -80px;
  padding-bottom: var(--mh2-space-lg);
}

.mh2v2-page .mh2v2-about-founder__caption h4 {
  text-shadow: 0 3px 16px rgba(0, 0, 0, 0.35);
}

.mh2v2-page .mh2v2-about-founder__caption p {
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.mh2v2-page .mh2v2-about-copy .mh2v2-section-title {
  margin-bottom: var(--mh2-space-lg);
}

.mh2v2-page .mh2v2-about-copy p + p {
  margin-top: var(--mh2-space-md);
}

/* ── 9. Footer (light touch) ───────────────────────────── */

.mh2v2-page .mh2v2-footer {
  padding: var(--mh2-space-xl) 0 var(--mh2-section-py-sm);
}

.mh2v2-page .mh2v2-newsletter input {
  border-radius: var(--radius-sm);
}

/* ── Responsive section polish ─────────────────────────── */

@media (max-width: 1100px) {
  .mh2v2-page .mh2v2-happening-grid {
    grid-template-columns: 1fr;
    gap: var(--mh2-gap-md);
  }

  .mh2v2-page .mh2v2-membership-box {
    max-width: 520px;
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .mh2v2-page .mh2v2-hero {
    min-height: 460px;
    height: auto;
  }

  .mh2v2-page .mh2v2-hero__title {
    max-width: none;
    font-size: clamp(2.4rem, 10vw, 3.2rem);
    margin-bottom: var(--mh2-space-md);
  }

  .mh2v2-page .mh2v2-happening-grid {
    margin-top: var(--mh2-space-xl);
  }

  .mh2v2-page .mh2v2-happening-card {
    grid-template-columns: 44px 1fr 40px;
    padding: var(--mh2-space-md);
  }

  .mh2v2-page .mh2v2-now-card {
    min-height: 360px;
  }

  .mh2v2-page .mh2v2-now-card img {
    min-height: 360px;
  }

  .mh2v2-page .mh2v2-now-card__footer {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--mh2-space-md);
  }

  .mh2v2-page .mh2v2-program-card__overlay {
    padding: var(--mh2-space-lg) var(--mh2-space-md);
  }

  .mh2v2-page .mh2v2-testimonial__content {
    padding: var(--mh2-space-xl) var(--mh2-space-lg);
  }

  .mh2v2-page .mh2v2-testimonial__media {
    min-height: 260px;
  }

  .mh2v2-page .mh2v2-mlist-hero img {
    height: 220px;
  }

  .mh2v2-page .mh2v2-center-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .mh2v2-page .mh2v2-center-actions .mh2v2-pill {
    width: 100%;
  }

  .mh2v2-page .mh2v2-about-founder img {
    height: 320px;
  }

  .mh2v2-page .mh2v2-founder-panel img {
    height: 280px;
  }

  .mh2v2-page .mh2v2-story-card__content {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/twentytwentysix/styles/homepageV2SectionPolish.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,6DAA6D;;AAE7D;EACE,eAAe;EACf,WAAW;EACX,qCAAqC;EACrC,yDAAyD;EACzD,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;EACxD;;;;GAIC;AACH;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC;;kCAEgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA,6DAA6D;;AAE7D;EACE,cAAc;EACd,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,gDAAgD;EAChD,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,6DAA6D;;AAE7D;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,6DAA6D;;AAE7D;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE;;;;;GAKC;EACD,gDAAgD;AAClD;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA,6DAA6D;;AAE7D;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,aAAa;AACf;;AAEA,+DAA+D;;AAE/D;EACE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iDAAiD;EACjD,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,+BAA+B;AACjC;;AAEA,+DAA+D;;AAE/D;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,8EAA8E;EAC9E,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;;EAEE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA,6DAA6D;;AAE7D;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,gDAAgD;EAChD,6BAA6B;EAC7B,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,6DAA6D;;AAE7D;EACE,uDAAuD;AACzD;;AAEA;EACE,+BAA+B;AACjC;;AAEA,6DAA6D;;AAE7D;EACE;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,sCAAsC;IACtC,kCAAkC;EACpC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,oCAAoC;IACpC,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;AACF","sourcesContent":["/*\n * Homepage V2 — Section polish pass (v1).\n * Section-level refinements built on homepageV2Foundation.css tokens.\n * Scoped to .mh2v2-page — no architecture changes.\n */\n\n/* ── 1. Hero ───────────────────────────────────────────── */\n\n.mh2v2-page .mh2v2-hero {\n  max-width: none;\n  width: 100%;\n  min-height: clamp(520px, 58vh, 680px);\n  padding: var(--mh2-space-2xl) var(--mh2-container-gutter);\n  border-radius: 0;\n}\n\n.mh2v2-page .mh2v2-hero__overlay {\n  padding: var(--mh2-space-xl) var(--mh2-container-gutter);\n  background: linear-gradient(\n    to bottom,\n    rgba(255, 255, 255, 0.12) 0%,\n    rgba(75, 68, 80, 0.22) 100%\n  );\n}\n\n.mh2v2-page .mh2v2-hero__overlay.mh2v2-container {\n  width: min(var(--container), calc(100% - (var(--mh2-container-gutter) * 2)));\n}\n\n.mh2v2-page .mh2v2-hero__title {\n  max-width: 14ch;\n  margin: 0 auto var(--mh2-space-lg);\n  text-shadow:\n    0 2px 8px rgba(0, 0, 0, 0.18),\n    0 8px 28px rgba(0, 0, 0, 0.12);\n}\n\n.mh2v2-page .mh2v2-hero .mh2v2-pill {\n  margin-top: var(--mh2-space-sm);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);\n}\n\n/* ── 2. Welcome / What's Happening ─────────────────────── */\n\n.mh2v2-page .mh2v2-welcome .mh2v2-script {\n  color: #d9737f;\n  margin-bottom: var(--mh2-space-lg);\n  max-width: 880px;\n}\n\n.mh2v2-page .mh2v2-welcome .mh2v2-copy--center {\n  max-width: 720px;\n  margin-bottom: var(--mh2-space-xs);\n}\n\n.mh2v2-page .mh2v2-region-row {\n  gap: var(--mh2-space-md);\n  margin-top: var(--mh2-space-xl);\n}\n\n.mh2v2-page .mh2v2-happening-grid {\n  margin-top: var(--mh2-space-2xl);\n  grid-template-columns: 1.25fr 0.88fr;\n  gap: var(--mh2-gap-lg);\n}\n\n.mh2v2-page .mh2v2-happening-left .mh2v2-section-title {\n  margin-bottom: var(--mh2-space-lg);\n}\n\n.mh2v2-page .mh2v2-happening-card {\n  padding: var(--mh2-space-md) var(--mh2-space-lg);\n}\n\n.mh2v2-page .mh2v2-happening-card__body h4 {\n  font-size: 1.08rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n}\n\n.mh2v2-page .mh2v2-happening-card__body p {\n  line-height: var(--mh2-line-body);\n  opacity: 0.92;\n}\n\n.mh2v2-page .mh2v2-membership-box {\n  padding: var(--mh2-space-xl) var(--mh2-space-lg);\n  box-shadow: 0 12px 36px rgba(75, 68, 80, 0.1);\n}\n\n.mh2v2-page .mh2v2-membership-box .mh2v2-section-title {\n  margin-bottom: var(--mh2-space-lg);\n}\n\n.mh2v2-page .mh2v2-membership-tier p {\n  line-height: var(--mh2-line-body);\n  margin-bottom: var(--mh2-space-md);\n}\n\n.mh2v2-page .mh2v2-membership-divider {\n  margin: var(--mh2-space-lg) 0;\n}\n\n/* ── 3. Featured Stories ───────────────────────────────── */\n\n.mh2v2-page .mh2v2-stories {\n  background: #d5b95a;\n}\n\n.mh2v2-page .mh2v2-stories .mh2v2-section-title {\n  margin-bottom: var(--mh2-space-xl);\n}\n\n.mh2v2-page .mh2v2-story-card {\n  background: var(--white);\n  border: 1px solid rgba(75, 68, 80, 0.07);\n}\n\n.mh2v2-page .mh2v2-story-card img {\n  height: 210px;\n  object-position: center 30%;\n}\n\n.mh2v2-page .mh2v2-story-card__content {\n  flex-direction: column;\n  align-items: flex-start;\n  padding: var(--mh2-card-padding-lg);\n  gap: var(--mh2-space-md);\n}\n\n.mh2v2-page .mh2v2-story-card__content p {\n  font-size: var(--mh2-size-body-sm);\n  line-height: var(--mh2-line-body);\n  font-weight: 600;\n  color: var(--text);\n}\n\n.mh2v2-page .mh2v2-story-card .mh2v2-inline-btn {\n  align-self: flex-start;\n}\n\n/* ── 4. What's Happening Now (Events) ──────────────────── */\n\n.mh2v2-page .mh2v2-now .mh2v2-section-title {\n  margin-bottom: var(--mh2-space-xl);\n}\n\n.mh2v2-page .mh2v2-now-card {\n  min-height: 400px;\n}\n\n.mh2v2-page .mh2v2-now-card img {\n  height: 100%;\n  min-height: 400px;\n  object-position: center 35%;\n}\n\n.mh2v2-page .mh2v2-now-card__overlay {\n  background: linear-gradient(\n    to top,\n    rgba(111, 159, 154, 0.88) 0%,\n    rgba(75, 68, 80, 0.15) 55%,\n    transparent 100%\n  );\n  padding: var(--mh2-space-xl) var(--mh2-space-lg);\n}\n\n.mh2v2-page .mh2v2-now-card__overlay h4 {\n  font-size: clamp(2.2rem, 3.5vw, 3rem);\n  line-height: 0.95;\n  margin-bottom: var(--mh2-space-md);\n  text-shadow: 0 3px 14px rgba(0, 0, 0, 0.2);\n}\n\n.mh2v2-page .mh2v2-now-card__footer p {\n  line-height: var(--mh2-line-body);\n  max-width: 220px;\n}\n\n/* ── 5. Signature Programs ─────────────────────────────── */\n\n.mh2v2-page .mh2v2-programs.mh2v2-section-charcoal {\n  background: #4f4853;\n}\n\n.mh2v2-page .mh2v2-programs .mh2v2-section-title {\n  margin-bottom: var(--mh2-space-xl);\n}\n\n.mh2v2-page .mh2v2-program-list {\n  gap: var(--mh2-gap-md);\n}\n\n.mh2v2-page .mh2v2-program-card__media {\n  height: 165px;\n}\n\n.mh2v2-page .mh2v2-program-card__media img {\n  object-position: center 30%;\n}\n\n.mh2v2-page .mh2v2-program-card__overlay {\n  gap: var(--mh2-space-md);\n  padding: var(--mh2-space-lg) var(--mh2-space-xl);\n}\n\n.mh2v2-page .mh2v2-program-card__overlay .mh2v2-pill {\n  margin: var(--mh2-space-xs) 0;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);\n}\n\n.mh2v2-page .mh2v2-program-card__overlay p {\n  line-height: var(--mh2-line-body);\n  opacity: 0.95;\n}\n\n/* ── 6. Testimonials ─────────────────────────────────────── */\n\n.mh2v2-page .mh2v2-testimonials .mh2v2-section-title {\n  margin-bottom: var(--mh2-space-xl);\n}\n\n.mh2v2-page .mh2v2-testimonial-list {\n  gap: var(--mh2-gap-md);\n}\n\n.mh2v2-page .mh2v2-testimonial__media {\n  min-height: 300px;\n}\n\n.mh2v2-page .mh2v2-testimonial__media img {\n  object-position: center 25%;\n}\n\n.mh2v2-page .mh2v2-testimonial__content {\n  padding: var(--mh2-space-2xl) var(--mh2-space-xl);\n  gap: var(--mh2-space-sm);\n}\n\n.mh2v2-page .mh2v2-testimonial__content h4 {\n  line-height: 1.08;\n  margin-bottom: var(--mh2-space-md);\n}\n\n.mh2v2-page .mh2v2-testimonial__content p {\n  margin-bottom: var(--mh2-space-md);\n}\n\n.mh2v2-page .mh2v2-testimonial__content strong {\n  font-size: 1.1rem;\n  margin-top: var(--mh2-space-sm);\n}\n\n.mh2v2-page .mh2v2-testimonial__content span {\n  font-size: var(--mh2-size-body-sm);\n  opacity: 0.88;\n  margin-top: var(--mh2-space-xs);\n}\n\n/* ── 7. The M List ───────────────────────────────────────── */\n\n.mh2v2-page .mh2v2-mlist-hero {\n  overflow: hidden;\n}\n\n.mh2v2-page .mh2v2-mlist-hero::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to right, rgba(75, 68, 80, 0.08), transparent 40%);\n  pointer-events: none;\n}\n\n.mh2v2-page .mh2v2-mlist-hero img {\n  height: 280px;\n  object-position: center 40%;\n}\n\n.mh2v2-page .mh2v2-mlist .mh2v2-copy--center {\n  max-width: 680px;\n  margin-bottom: var(--mh2-space-md);\n}\n\n.mh2v2-page .mh2v2-center-actions {\n  gap: var(--mh2-space-md);\n  margin: var(--mh2-space-lg) 0 var(--mh2-space-xl);\n}\n\n.mh2v2-page .mh2v2-center-actions .mh2v2-pill + .mh2v2-pill {\n  background: transparent;\n  color: var(--gold);\n  border: 2px solid var(--gold);\n  box-shadow: none;\n}\n\n.mh2v2-page .mh2v2-center-actions .mh2v2-pill + .mh2v2-pill:hover {\n  background: rgba(216, 176, 78, 0.12);\n  transform: translateY(-2px);\n}\n\n.mh2v2-page .mh2v2-mlist .mh2v2-section-title + .mh2v2-section-title,\n.mh2v2-page .mh2v2-mlist h4.mh2v2-section-title {\n  margin-top: var(--mh2-space-xl);\n  margin-bottom: var(--mh2-space-lg);\n}\n\n.mh2v2-page .mh2v2-category-card img {\n  height: 220px;\n  object-position: center 30%;\n}\n\n.mh2v2-page .mh2v2-category-card__overlay h5 {\n  font-size: clamp(2.2rem, 3vw, 2.8rem);\n  margin-bottom: var(--mh2-space-md);\n  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);\n}\n\n.mh2v2-page .mh2v2-category-links {\n  gap: var(--mh2-space-sm);\n  padding: var(--mh2-space-md);\n}\n\n.mh2v2-page .mh2v2-category-link {\n  font-size: 0.88rem;\n  padding: 10px var(--mh2-space-md);\n}\n\n/* ── 8. Collective / Founder / About ───────────────────── */\n\n.mh2v2-page .mh2v2-collective .mh2v2-section-title {\n  margin-bottom: var(--mh2-space-xl);\n}\n\n.mh2v2-page .mh2v2-collective-info p {\n  line-height: var(--mh2-line-body);\n  margin-bottom: var(--mh2-space-md);\n}\n\n.mh2v2-page .mh2v2-quote-chip {\n  border-radius: var(--mh2-card-radius);\n  padding: var(--mh2-space-lg) var(--mh2-space-xl);\n  margin-top: var(--mh2-gap-lg);\n  font-size: clamp(1.3rem, 2.5vw, 1.6rem);\n  line-height: 1.15;\n}\n\n.mh2v2-page .mh2v2-founder-panel img {\n  height: 340px;\n  object-position: center 20%;\n}\n\n.mh2v2-page .mh2v2-founder-panel__body {\n  padding-top: var(--mh2-space-md);\n  gap: var(--mh2-space-md);\n}\n\n.mh2v2-page .mh2v2-founder-panel__body p {\n  line-height: var(--mh2-line-body);\n}\n\n.mh2v2-page .mh2v2-about.mh2v2-section-charcoal {\n  background: #4f4853;\n}\n\n.mh2v2-page .mh2v2-about-founder img {\n  height: 400px;\n  object-position: center 15%;\n}\n\n.mh2v2-page .mh2v2-about-founder__caption {\n  margin-top: -80px;\n  padding-bottom: var(--mh2-space-lg);\n}\n\n.mh2v2-page .mh2v2-about-founder__caption h4 {\n  text-shadow: 0 3px 16px rgba(0, 0, 0, 0.35);\n}\n\n.mh2v2-page .mh2v2-about-founder__caption p {\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n}\n\n.mh2v2-page .mh2v2-about-copy .mh2v2-section-title {\n  margin-bottom: var(--mh2-space-lg);\n}\n\n.mh2v2-page .mh2v2-about-copy p + p {\n  margin-top: var(--mh2-space-md);\n}\n\n/* ── 9. Footer (light touch) ───────────────────────────── */\n\n.mh2v2-page .mh2v2-footer {\n  padding: var(--mh2-space-xl) 0 var(--mh2-section-py-sm);\n}\n\n.mh2v2-page .mh2v2-newsletter input {\n  border-radius: var(--radius-sm);\n}\n\n/* ── Responsive section polish ─────────────────────────── */\n\n@media (max-width: 1100px) {\n  .mh2v2-page .mh2v2-happening-grid {\n    grid-template-columns: 1fr;\n    gap: var(--mh2-gap-md);\n  }\n\n  .mh2v2-page .mh2v2-membership-box {\n    max-width: 520px;\n    margin: 0 auto;\n  }\n}\n\n@media (max-width: 768px) {\n  .mh2v2-page .mh2v2-hero {\n    min-height: 460px;\n    height: auto;\n  }\n\n  .mh2v2-page .mh2v2-hero__title {\n    max-width: none;\n    font-size: clamp(2.4rem, 10vw, 3.2rem);\n    margin-bottom: var(--mh2-space-md);\n  }\n\n  .mh2v2-page .mh2v2-happening-grid {\n    margin-top: var(--mh2-space-xl);\n  }\n\n  .mh2v2-page .mh2v2-happening-card {\n    grid-template-columns: 44px 1fr 40px;\n    padding: var(--mh2-space-md);\n  }\n\n  .mh2v2-page .mh2v2-now-card {\n    min-height: 360px;\n  }\n\n  .mh2v2-page .mh2v2-now-card img {\n    min-height: 360px;\n  }\n\n  .mh2v2-page .mh2v2-now-card__footer {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--mh2-space-md);\n  }\n\n  .mh2v2-page .mh2v2-program-card__overlay {\n    padding: var(--mh2-space-lg) var(--mh2-space-md);\n  }\n\n  .mh2v2-page .mh2v2-testimonial__content {\n    padding: var(--mh2-space-xl) var(--mh2-space-lg);\n  }\n\n  .mh2v2-page .mh2v2-testimonial__media {\n    min-height: 260px;\n  }\n\n  .mh2v2-page .mh2v2-mlist-hero img {\n    height: 220px;\n  }\n\n  .mh2v2-page .mh2v2-center-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .mh2v2-page .mh2v2-center-actions .mh2v2-pill {\n    width: 100%;\n  }\n\n  .mh2v2-page .mh2v2-about-founder img {\n    height: 320px;\n  }\n\n  .mh2v2-page .mh2v2-founder-panel img {\n    height: 280px;\n  }\n\n  .mh2v2-page .mh2v2-story-card__content {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
